module.exports = __webpack_public_path__ + "static/media/inv.bd9b64cb.jpg";